const isCoordEqual = (coord1, coord2) => coord1[0] === coord2[0] && coord1[1] === coord2[1]
const validateCoord = (coord) => Array.isArray(coord) && coord.length === 2 && !Number.isNaN(coord[0]) && !Number.isNaN(coord[1])

function* mapLinearRingCoord(coords) {
  if (!Array.isArray(coords)) throw new Error();
  if (coords.length < 4) throw new Error();
  if (!validateCoord(coords[0])) throw new Error();
  if (!validateCoord(coords.at(-1))) throw new Error();
  if (!isCoordEqual(coords[0], coords.at(-1))) throw new Error();
  
  yield coords[0]
  for (let idx in coords) {
    if (idx < 1) continue;
    const coord = coords[idx]
    if (!validateCoord(coord)) throw new Error();
    if (!isCoordEqual(coords[idx-1], coord)) yield coord;
  }
}

function mapPolygonCoord(coords) {
  if (!Array.isArray(coords)) return null;
  if (coords.length < 1) return null;
  
  try {
    return coords.map(coord => [...mapLinearRingCoord(coord)])
  }
  catch(_) {
    return null
  }
}

function* parseGeoJSON(geojsons) {
  for (let geojson of geojsons) {
    switch (geojson?.type) {
      case 'FeatureCollection':
        if (!Array.isArray(geojson?.features)) throw new Error();
        yield* parseGeoJSON(geojson.features)
        break
      
      case 'Feature':
        yield* parseGeoJSON([geojson?.geometry])
        break
      
      case 'GeometryCollection':
        if (!Array.isArray(geojson?.geometries)) throw new Error();
        yield* parseGeoJSON(geojson.geometries)
        break
      
      case 'MultiPolygon':
        if (!Array.isArray(geojson?.coordinates)) throw new Error();
        yield* parseGeoJSON(geojson.coordinates.map(coord => ({ type: 'Polygon', coordinates: coord })))
        break
      
      case 'Polygon':
        const coordinates = mapPolygonCoord(geojson?.coordinates)
        if (!coordinates) throw new Error();
        yield { type: 'Polygon', coordinates: coordinates }
        break
      
      default:
        throw new Error()
    }
  }
}

function parseCoordinates(coords) {
  try {
    return [...parseGeoJSON([{ type: 'MultiPolygon', coordinates: coords }])]
  }
  catch(_) {
    return [...parseGeoJSON([{ type: 'Polygon', coordinates: coords }])]
  }
}

export { parseGeoJSON, parseCoordinates }
